import { useEffect, useState } from "react";
import { IconImg } from "../../../contents/Icons";
import { Dashboard } from "./dashboard";
import { Map } from "./map";
import { StyledSection1 } from "./style";
import { API } from "../../../apis/dashboard.api";
import { Util } from "../../../util/Util";
import { REGIONS } from "../../../consts/const";

import useRegionStore from "../../../store/useRegionStore";
import useDateRangeStore from "../../../store/useDateRangeStore";
import useLoadingStore from "../../../store/useLoadingState";

export const Section1 = () => {
  const { selectedRegion } = useRegionStore();
  const { mainStartDate, mainEndDate } = useDateRangeStore();
  const { setIsLoading } = useLoadingStore();

  const [statisticData, setStatisticData] = useState();
  const [operationTime, setOperationTime] = useState();

  const getData = async () => {
    try {
      setIsLoading(true, "LOADING...");

      let requestBody = {
        startDate: Util.formatDate(mainStartDate),
        endDate: Util.formatDate(mainEndDate),
      };
      if (selectedRegion !== null) {
        requestBody = {
          ...requestBody,
          departmentId: selectedRegion,
        };
      }

      const result = await API.getStatsticRegion(requestBody);
      if (await result) {
        setStatisticData(result.statisticData);
        setOperationTime(
          result.operationTime
            .map((oper, idx) => {
              return {
                ...oper,
                order: oper.departmentSeq.split("-")[1],
                departmentSeq:
                  oper.departmentSeq.split("-").join(" - ") + "번 기기",
              };
            })
            .sort((a, b) => a.order - b.order)
        );
        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [selectedRegion, mainStartDate, mainEndDate]);

  return (
    <StyledSection1>
      <div className="section1-container">
        <div className="frame frame-l">
          <div className="title-box">
            <IconImg.Company />
            <p>국토관리사무소별</p>
          </div>
          <Map />
        </div>

        <div className="frame frame-r">
          <div className="title-box">
            <IconImg.Network />
            <p className="title">포트홀 현황</p>
          </div>
          <p className="region-title">
            {statisticData
              ? selectedRegion !== null
                ? `${REGIONS[selectedRegion].label}국토관리사무소`
                : "국토관리사무소"
              : "Loading..."}
          </p>
          <Dashboard
            statisticData={statisticData}
            operationTime={operationTime}
          />
        </div>
      </div>
    </StyledSection1>
  );
};
